import { render, staticRenderFns } from "./LogOffIcon.vue?vue&type=template&id=4c0e3126&scoped=true&"
import script from "./LogOffIcon.vue?vue&type=script&lang=js&"
export * from "./LogOffIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogOffIcon.vue?vue&type=style&index=0&id=4c0e3126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e3126",
  null
  
)

export default component.exports